export default function () {
    const $objfitImg = $('.object-fit-image');
    objectFitImages($objfitImg);
}
